import script from "./PilaresSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PilaresSection.vue?vue&type=script&setup=true&lang=js"

import "./PilaresSection.vue?vue&type=style&index=0&id=9297e064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9297e064"]])

export default __exports__